export const blogPosts = [
  {
    slug: "combien-coute-site-vitrine",
    title: "Prix d'un site vitrine : tarifs, exemples et budget à prévoir",
    metaTitle:
      "Prix d'un site vitrine : tarifs, exemples et budget | Fold Web Agency",
    metaDescription:
      "Découvrez le prix d'un site vitrine professionnel, les critères qui font varier le budget, les fourchettes de tarifs et les erreurs à éviter.",
    excerpt:
      "Un site vitrine peut coûter quelques centaines à plusieurs milliers d'euros selon le niveau de design, le contenu, le SEO et les fonctionnalités.",
    category: "Site vitrine",
    readingTime: "8 min",
    publishedAt: "2026-07-16",
    intro:
      "Le prix d'un site vitrine professionnel dépend du nombre de pages, du niveau de personnalisation, des contenus, du SEO et des fonctionnalités attendues. L'objectif n'est pas seulement d'avoir une page en ligne, mais un support clair, crédible et capable de générer des contacts.",
    priceRanges: [
      {
        label: "Site vitrine simple",
        price: "600 à 1 500 €",
        description:
          "Quelques pages essentielles, design propre, formulaire de contact et base responsive.",
      },
      {
        label: "Site vitrine professionnel",
        price: "1 500 à 3 500 €",
        description:
          "Design personnalisé, pages services, structure SEO, contenus mieux travaillés et mise en ligne soignée.",
      },
      {
        label: "Site vitrine avancé",
        price: "3 500 € et plus",
        description:
          "Stratégie de contenu, pages nombreuses, animations, intégrations, espace client ou besoins spécifiques.",
      },
    ],
    sections: [
      {
        title: "Ce qui influence le prix",
        body:
          "Un site vitrine simple avec quelques pages ne demande pas le même travail qu'un site complet avec stratégie SEO, pages services, formulaire avancé, contenus rédigés et intégrations spécifiques. Le prix dépend aussi du niveau d'accompagnement : cadrage, maquette, rédaction, optimisation, mise en ligne et suivi.",
      },
      {
        title: "Fourchettes de prix à connaître",
        body:
          "Un site vitrine très simple peut démarrer autour de quelques centaines d'euros, mais un site professionnel réellement utile demande souvent un budget plus élevé. Il faut prendre en compte la conception, le design, l'intégration, la rédaction, le responsive, les optimisations SEO et les tests avant mise en ligne.",
      },
      {
        title: "Pourquoi éviter le site trop basique",
        body:
          "Un site très peu cher peut sembler attractif au départ, mais il manque souvent de structure, de performance et de contenu. Si Google comprend mal les pages ou si les visiteurs ne trouvent pas rapidement l'information, le site risque de ne pas apporter de résultats concrets.",
      },
      {
        title: "WordPress ou site sur mesure : impact sur le budget",
        body:
          "WordPress peut réduire le coût si le besoin reste classique et administrable. Le sur mesure devient pertinent lorsque l'expérience, les performances ou les fonctionnalités sortent des standards. Dans les deux cas, la qualité du cadrage et des contenus compte autant que la technologie.",
      },
      {
        title: "Le bon investissement",
        body:
          "Un bon site vitrine doit présenter l'activité, rassurer, répondre aux questions principales et faciliter la prise de contact. C'est un investissement durable quand il est pensé avec une base technique propre, des messages clairs et une structure évolutive.",
      },
    ],
    cta: {
      title: "Besoin d'estimer le budget de votre site ?",
      body:
        "Décrivez votre activité, le nombre de pages souhaitées et vos objectifs. Nous vous aidons à définir une solution cohérente avec votre budget.",
      linkLabel: "Demander une estimation",
      linkTo: "/#contact",
    },
    faq: [
      {
        question: "Quel budget prévoir pour un site vitrine ?",
        answer:
          "Le budget dépend du nombre de pages, du design, des contenus et du niveau d'optimisation. Pour un site professionnel, il faut souvent prévoir plus qu'une simple page en ligne : structure, crédibilité, SEO et conversion.",
      },
      {
        question: "Le SEO est-il inclus dans un site vitrine ?",
        answer:
          "Les bases SEO peuvent être intégrées dès la création : balises, structure, performance, sitemap et maillage interne. Un travail SEO avancé demande ensuite un suivi dédié.",
      },
      {
        question: "Pourquoi les prix varient-ils autant ?",
        answer:
          "Parce qu'un site peut aller d'une vitrine très simple à un support commercial complet avec stratégie, rédaction, pages SEO, design personnalisé et fonctionnalités spécifiques.",
      },
    ],
  },
  {
    slug: "wordpress-ou-site-sur-mesure",
    title: "Site WordPress ou site sur mesure : que choisir ?",
    metaTitle: "WordPress ou site sur mesure : que choisir ? | Fold Web Agency",
    metaDescription:
      "Comparatif clair entre site WordPress et site sur mesure pour choisir la bonne solution web.",
    excerpt:
      "WordPress et le sur mesure répondent à des besoins différents. Le bon choix dépend de votre autonomie, de votre budget et de vos objectifs.",
    category: "Conseil web",
    readingTime: "6 min",
    publishedAt: "2026-07-16",
    intro:
      "Le choix entre WordPress et un site sur mesure revient souvent au moment de créer ou refondre un site professionnel. Il n'y a pas de réponse universelle : la meilleure solution dépend de votre besoin réel, de votre organisation et de la manière dont le site devra évoluer.",
    sections: [
      {
        title: "Quand choisir WordPress",
        body:
          "WordPress est pertinent si vous voulez gérer facilement vos contenus, publier des pages, ajouter des articles ou garder une certaine autonomie. Bien configuré, il permet de créer un site professionnel, administrable et évolutif.",
      },
      {
        title: "Quand choisir le sur mesure",
        body:
          "Un site sur mesure est utile quand le besoin sort des standards : interface spécifique, performance poussée, parcours personnalisé, espace client ou logique métier particulière. Il permet plus de contrôle, mais demande souvent un cadrage plus précis.",
      },
      {
        title: "Le vrai critère de décision",
        body:
          "La question n'est pas seulement technique. Il faut choisir la solution qui servira le mieux vos objectifs : gagner en crédibilité, générer des contacts, publier régulièrement, vendre une offre ou gérer une relation client.",
      },
    ],
    faq: [
      {
        question: "WordPress est-il moins professionnel qu'un site sur mesure ?",
        answer:
          "Non. Un site WordPress bien conçu peut être très professionnel. La qualité dépend surtout de la structure, du design, des contenus et de la configuration technique.",
      },
      {
        question: "Un site sur mesure est-il meilleur pour le SEO ?",
        answer:
          "Pas automatiquement. Le SEO dépend de la vitesse, de la structure, des contenus et du maillage. Les deux solutions peuvent être performantes si elles sont bien construites.",
      },
    ],
  },
  {
    slug: "ameliorer-referencement-site-vitrine",
    title: "Comment améliorer le référencement d'un site vitrine ?",
    metaTitle:
      "Comment améliorer le référencement d'un site vitrine ? | Fold Web Agency",
    metaDescription:
      "Actions concrètes pour améliorer le SEO d'un site vitrine professionnel et attirer un trafic qualifié.",
    excerpt:
      "Un site vitrine progresse en SEO quand ses pages répondent clairement aux recherches des prospects et sont bien reliées entre elles.",
    category: "Référencement SEO",
    readingTime: "7 min",
    publishedAt: "2026-07-16",
    intro:
      "Améliorer le référencement d'un site vitrine demande un travail régulier sur la technique, les contenus et la confiance. L'objectif est d'aider Google à comprendre ce que vous proposez, pour qui, et pourquoi vos pages méritent d'être affichées.",
    sections: [
      {
        title: "Structurer les pages par intention",
        body:
          "Chaque page doit répondre à une recherche précise : création de site vitrine, maintenance WordPress, référencement SEO, portfolio ou contact. Une page claire avec un titre précis, des sections utiles et une FAQ a plus de chances d'être comprise.",
      },
      {
        title: "Renforcer le maillage interne",
        body:
          "Les liens internes aident Google à comprendre les relations entre les pages. Une page service peut renvoyer vers un article de blog, un cas client ou une autre offre complémentaire. Ce maillage améliore aussi la navigation des visiteurs.",
      },
      {
        title: "Construire la notoriété",
        body:
          "Le SEO ne dépend pas seulement du site. Les liens depuis des profils professionnels, des partenaires, des clients ou des annuaires sérieux renforcent la confiance. Mieux vaut quelques liens pertinents que beaucoup de liens faibles.",
      },
    ],
    faq: [
      {
        question: "Combien de temps faut-il pour améliorer son SEO ?",
        answer:
          "Les premiers signaux peuvent apparaître en quelques semaines, mais une progression durable se mesure plutôt sur plusieurs mois.",
      },
      {
        question: "Faut-il publier beaucoup d'articles ?",
        answer:
          "Non. Il vaut mieux publier des articles utiles, structurés et reliés aux pages services plutôt que produire beaucoup de contenus superficiels.",
      },
    ],
  },
];

export const getBlogPostBySlug = (slug) =>
  blogPosts.find((post) => post.slug === slug);
